import React from 'react'
import PropTypes from 'prop-types'
import { CategoryNavigation } from './CategoryNavigation'
import { SubCategorySelector } from './SubCategorySelector'
import { HOME_CATEGORY } from 'LiveBoard/modules/itemsView'
import { CATEGORY_TYPES } from 'LiveBoard/config/constants'
import filter from 'lodash/filter'
import pullAll from 'lodash/pullAll'

import './style.css.scss'

const Header = (props) => {
  const {
    categories, categoryIds, selectedCategoryId, showHomeCategory,
    onCategoryClick, themeColorHex
  } = props

  const getParentCategory = (category) => {
    const { parent_category_id: parentCategoryId } = category
    return parentCategoryId ? categories[parentCategoryId] : null
  }

  const selectedCategory = (selectedCategoryId == HOME_CATEGORY.id) ?
    HOME_CATEGORY : categories[selectedCategoryId]
  const parentCategory = getParentCategory(selectedCategory)
  const primaryCategory = parentCategory || selectedCategory
  const subCategory = parentCategory ? selectedCategory : null
  const linkCategories = filter(categories, c => c.category_type == CATEGORY_TYPES.linkCategory)
  //spreading categoryIds because the next actions are mutating the object that comes from redux's state
  let itemCategoryIds = pullAll([...categoryIds], linkCategories.map(c => c.id))
  showHomeCategory && itemCategoryIds.unshift(HOME_CATEGORY.id)

  return (
    <div className="items-header">
      <CategoryNavigation
        selectedCategory={primaryCategory}
        categoryIds={itemCategoryIds}
        onClick={onCategoryClick}
        themeColorHex={themeColorHex}
        showHomeCategory={showHomeCategory} />
      { subCategory && (
        <SubCategorySelector
          selectedSubCategoryId={subCategory.id}
          categories={categories}
          subcategoryIds={primaryCategory.subcategories_ids}
          onClick={onCategoryClick}
          themeColorHex={themeColorHex} />
      )}
    </div>
  )
}

Header.propTypes = {
  categories: PropTypes.object.isRequired,
  categoryIds: PropTypes.array,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  onCategoryClick: PropTypes.func,
  themeColorHex: PropTypes.string,
  showHomeCategory: PropTypes.bool
}

export default Header
